import React from 'react';
import {
    Box,
    Button,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const FIELDS = [
    {value: 'year_of_birth', label: 'Year of Birth', type: 'number'},
    {value: 'country_of_residence', label: 'Country', type: 'text'},
    {value: 'zip_code', label: 'ZIP Code', type: 'text'},
    {
        value: 'region',
        label: 'Region (Germany)',
        type: 'select',
        options: ["BW", "BY", "BE", "BB", "HB", "HH", "HE", "MV", "NI", "NW", "RP", "SL", "SN", "ST", "SH", "TH"]
    },
    {
        value: 'gender',
        label: 'Gender',
        type: 'select',
        options: ["MALE", "FEMALE", "DIVERSE", "INTER", "NONBINARY", "GENDERFLUID", "NONE"]
    },
    {value: 'height_mm', label: 'Height (mm)', type: 'number'},
    {value: 'weight_g', label: 'Weight (g)', type: 'number'},
    {value: 'yearly_income_cents', label: 'Yearly Income (Cents)', type: 'number'},
    {
        value: 'relationship_status',
        label: 'Relationship Status',
        type: 'select',
        options: ["SINGLE", "COUPLE", "MARRIED", "POLY", "COLORFUL"]
    },
];

const OPERATORS = ['=', '!=', '>', '<', '>=', '<=', 'in', 'contains'];

const FilterBuilder = ({filters, onFiltersChange, disabled}) => {

    const handleAddFilter = () => {
        onFiltersChange([...filters, ['', '=', '']]);
    };

    const handleRemoveFilter = (index) => {
        onFiltersChange(filters.filter((_, i) => i !== index));
    };

    const handleFilterUpdate = (index, part, value) => {
        const newFilters = [...filters];
        newFilters[index][part] = value;
        onFiltersChange(newFilters);
    };

    return (
        <Box>
            {filters.map((filter, index) => (
                <Paper key={index} sx={{p: 2, mb: 2, border: '1px solid #ddd'}}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <InputLabel>Field</InputLabel>
                                <Select
                                    value={filter[0]}
                                    label="Field"
                                    onChange={(e) => handleFilterUpdate(index, 0, e.target.value)}
                                    disabled={disabled}
                                >
                                    {FIELDS.map(f => <MenuItem key={f.value} value={f.value}>{f.label}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <InputLabel>Operator</InputLabel>
                                <Select
                                    value={filter[1]}
                                    label="Operator"
                                    onChange={(e) => handleFilterUpdate(index, 1, e.target.value)}
                                    disabled={disabled}
                                >
                                    {OPERATORS.map(op => <MenuItem key={op} value={op}>{op}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Value"
                                fullWidth
                                value={filter[2]}
                                onChange={(e) => handleFilterUpdate(index, 2, e.target.value)}
                                helperText={filter[1] === 'in' ? 'Use comma-separated values, e.g., value1,value2' : ''}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <IconButton onClick={() => handleRemoveFilter(index)} color="error" disabled={disabled}>
                                <DeleteIcon/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
            <Button
                startIcon={<AddCircleOutlineIcon/>}
                onClick={handleAddFilter}
                variant="outlined"
                disabled={disabled}
            >
                Add Filter
            </Button>
        </Box>
    );
};

export default FilterBuilder;